export default __webpack_public_path__ + "static/media/AdobeStock_175697403.5378cdcc.png";